import React from 'react'
import Snackbar from '@mui/material/Snackbar';
import Slide, { SlideProps } from '@mui/material/Slide';
import Alert from '@mui/material/Alert';
import { useMediaQuery } from '@mui/material';

type TransitionProps = Omit<SlideProps, 'direction'>;

function TransitionSlide(props: TransitionProps) {
    return <Slide {...props} direction="down" />;
}


interface propSnackbar {
    IsOpen: boolean;
    Severity: string;
    // Severity: 'error' | 'info' | 'success' | 'warning';
    OnClose?: any;
    AutoHideInTime?: number;
    Message?: any;
    Variant?: 'filled' | 'outlined' | 'standard';
    Sx?: any;
    style?: any;
}

export const SnackbarCustom = (props : propSnackbar) => {

    const { IsOpen, Severity, OnClose, AutoHideInTime = 5000, Message, Variant, Sx, style } = props;
    const Layout600 = useMediaQuery('(min-width:600px)');

    return (
       <>
            <Snackbar 
                key={Severity+""}
                open={IsOpen} 
                autoHideDuration={AutoHideInTime} 
                onClose={OnClose}
                TransitionComponent={TransitionSlide}
                anchorOrigin={{  vertical: 'top', horizontal: 'center' }}
                sx={{...Sx}}
                style={{width:'max-content', top:'80px', maxWidth: Layout600 ? '50%' : '60%', left: Layout600 ? '50%' : '30%', ...style}}
            >
                <Alert 
                    severity={Severity === "success" ? "success" : Severity === "error" ? "error" : Severity === "warning" ? "warning" : "info" } 
                    variant={Variant}
                    onClose={OnClose}
                    style={{
                        display:'flex',
                        alignItems:'center'
                    }}
                > 
                    {Message ?? ""}
                </Alert>
            </Snackbar>
       </>
    );
};